module.exports = __webpack_public_path__ + "static/media/shield.65e1e938.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/shield.svg
// module id = 3003
// module chunks = 0